<template>
  <div class="card py-3">
    <div class="box box-services" v-if="source === 'RHOMTRIP'">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row card-experience-reserv">
            <div
              class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
            >
              <LazyImage
                :src="product.images[0] || noImage"
                :alt="`${product.name}`"
                imgClasses="img-experiences-min"
              />
            </div>
            <div
              class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-12 align-self-center"
            >
              <a
                :href="`/experiences/rhomtrip/${product._id}`"
                target="_blank"
                class="link-experiences mt-sm-0 mt-3"
              >
                {{ product.name }}<i class="flaticon-link ml-1 f-14"></i>
              </a>

              <div class="descrip">
                <p class="short-description">
                  {{ product.shortdescription }}
                </p>

                <div class="d-flex">
                  <span
                    ><i class="flaticon-employees mr-1"></i>
                    {{ product.passengers.maximum }}
                    <i class="flaticon-briefcase mr-1 ml-2"></i>
                    {{ product.bags.maximum }}

                    <i
                      class="flaticon-clock ml-2  mr-1"
                      v-if="product.type === 'TOUR'"
                    ></i>
                    <span v-if="product.type === 'TOUR'">
                      {{ product.durationValue }}
                      {{
                        getUnitTime(product.durationUnit, product.durationValue)
                      }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box box-services" v-else-if="source === 'VENTRATA'">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row card-experience-reserv">
            <div
              class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
            >
              <LazyImage
                :src="getProductImages(product)"
                :alt="`${product.title}`"
                imgClasses="img-experiences-min"
              />
            </div>
            <div
              class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-12 align-self-center"
            >
              <a
                :href="
                  `/experiences/ventrata/${productId}?providerId=${product.providerId}`
                "
                target="_blank"
                class="link-experiences mt-sm-0 mt-3"
              >
                {{ product.title }}<i class="flaticon-link ml-1 f-14"></i>
              </a>

              <div class="descrip">
                <p class="short-description" v-if="product.shortDescription">
                  {{ product.shortDescription }}
                </p>

                <p class="short-description" v-else="product.shortDescription">
                  An experience that will make you enjoy incredible moments and
                  create unforgettable memories, transforming the way you see
                  the world.
                </p>

                <div class="d-flex">
                  <i class="flaticon-clock mr-2"></i>
                  <span>
                    {{ duration }}

                    {{ getDurationByOption(product.options) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WEBSITE_BASE_URL } from "../../../core/config/env";
export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      required: true,
      description: "(closeable)"
    },
    source: {
      type: String,
      required: true,
      default: "",
      description: "RHOMTRIP, VENTRATA"
    },
    productId: {
      type: String,
      required: false,
      default: "",
      description: "Product ID VENTRATA"
    },
    duration: {
      type: String,
      required: false,
      default: "",
      description: "duration"
    }
  },
  data() {
    return {
      noImage: require("rhomtrip_assets/src/img/no-image-available.png")
    };
  },
  methods: {
    gotToProductDetails(
      productType,
      countrySlug,
      destinationSlug,
      productSlug
    ) {
      return `${WEBSITE_BASE_URL}/experiences/${this.getSlugByProductType(
        productType
      )}/${countrySlug}/${destinationSlug}/${productSlug}`;
    },
    getSlugByProductType: function(type) {
      if ("PRIVATE_TRANSFER" === type) {
        return "private-transfer";
      } else if ("TOUR" === type) {
        return "tours";
      } else if ("EVENT" === type) {
        return "event";
      } else if ("ATTRACTION" === type) {
        return "attraction";
      }
    },
    getUnitTime(unit, value) {
      if ("HOURS" === unit) {
        return value > 1 ? "hours" : "hour";
      } else if ("MINUTES" === unit) {
        return value > 1 ? "Minutes" : "Minute";
      } else if ("DAYS" === unit) {
        return value > 1 ? "days" : "day";
      } else {
        return "";
      }
    },
    getProductImages(product) {
      if (product.coverImageUrl) {
        return product.coverImageUrl;
      } else if (product.galleryImages.length) {
        let [image] = product.galleryImages.map(gallery => gallery.url);
        return image;
      } else if (product.bannerImageUrl) {
        return product.bannerImageUrl;
      } else if (product.bannerImages.length) {
        let [image] = product.bannerImages.map(banner => banner.url);
        return image;
      } else {
        return this.noImage;
      }
    },

    getDurationByOption(options = []) {
      let [option] = options;
      return option ? option.duration : "";
    }
  },
  computed: {}
};
</script>
